export const getEndpoint = (type, propertyId, controlId, fileId, contractId = null, userTempToken = null, templateFilename = null) => {
    const endpoints = {
        properties: {
            list: `proprietes/list`,
            create: `proprietes/create`,
            detail: `/proprietes/${propertyId}`,
            edit: `proprietes/edit/${propertyId}`,
            delete: `/fr/proprietes/${propertyId}`,
            propertyTypes: `proprietes/types`,
            previewFile: `proprietes/file/${fileId}/preview`,
            download: `proprietes/file/${fileId}/download`,
            absoluteDownloadUrl: `/fr/proprietes/file/${fileId}/download`,
            historiesList: `/fr/proprietes/{$propertyId}/history/control/${controlId}`,
            historiesCreate: `/fr/proprietes/{$propertyId}/history/control/${controlId}`,
        },
        controls: {
            controlsList: `controls/list`,
            controls: `proprietes/${propertyId}/control`,
            control: `/proprietes/${propertyId}/control/${controlId}`,
        },
        conformite: {
            create: `conformite/create`,
            detail: `conformite/${controlId}/detail`,
            edit: `conformite/${controlId}/edit`,
            delete: `/fr/conformite/${controlId}`,
        },
        vpt: {
            create: `vpt/create`,
            detail: `vpt/${controlId}/detail`,
            edit: `vpt/${controlId}/edit`,
            delete: `/fr/vpt/${controlId}`,
        },
        ve: {
            create: `ve/create`,
            detail: `ve/${controlId}/detail`,
            edit: `ve/${controlId}/edit`,
            delete: `/fr/ve/${controlId}`,
        },
        workflow: {
            status: `workflow/${controlId}/status`,
            timeline: `workflow/${controlId}/timeline`,
            nextStatuses: `workflow/${controlId}/status/next`,
            changeStatus: `workflow/${controlId}/status/change`,
        },
        referential: {
            preTreatmentEquipments: `referential/preTreatmentEquipments`,
            networkTypes: `referential/networkTypes`,
            networkProperties: `referential/networkProperties`,
            visitDisposals: `referential/visitDisposals`,
            stormWaterStructure: `referential/stormWaterStructure`,
            towns: `referential/towns`,
            cities: `referential/city`,
        },
        user: {
            list: `user/list`,
        },
        file: {
            downloadFile: `file/${controlId}/preview/${fileId}`,
            download: `file/${controlId}/download/${fileId}`,
            absoluteDownloadUrl: `/fr/file/${controlId}/download/${fileId}`,
        },
        filter: {
            search: `search`,
        },
        trackingContractTemplates: {
            get: `/fr/tracking/contract/${contractId}/templates`,
        },
        trackingContractMails: {
            get: `/fr/tracking/contract/${contractId}/mails`,
            post: `/fr/tracking/contract/${contractId}/mails`,
        },
        trackingContractInvoices: {
            get: `/fr/tracking/contract/${contractId}/invoices`,
            post: `/fr/tracking/contract/${contractId}/invoices`,
        },
        userRequests: {
            get: `/user_request/statistics/dateHistogram`,
        },
        synthesis: {
            getDateHistogram: `/syntheses/statistics/dateHistogram`,
            getLastUpdatedDate: `/syntheses/last_synthesis_update_date`,
            getQuery: `query`,
            getTypes: `/syntheses/types`,
        },
        userTempToken: {
            get: `/fr/user/temp-token`,
        },
        drawio: {
            config: `/fr/drawio/config?temp-token=${userTempToken}`,
            file: `/fr/drawio/control/${controlId}/download/${fileId}`,
            template: `/fr/drawio/templates/${templateFilename}`,
            downloadPropertyFile: `/fr/drawio/properties/file/${fileId}/download`,
        },
    };

    return endpoints[type];
};
